import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_club,
  add_club,
  update_club,
  delete_club,
  get_club_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  clubs: [],
  clublist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:"",
  },
};

// Async Thunks for API Calls
export const fetchclublist = createAsyncThunk(
    'club/fetchclublist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_club_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchclub = createAsyncThunk(
  "club/fetchclub",
  async ({ page, page_size,filter_fields,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_club(page, page_size,filter_fields,school_id, token, signal);
      
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createclub = createAsyncThunk(
  "club/createclub",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_club(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateclub = createAsyncThunk(
  "club/updateclub",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_club(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteclub = createAsyncThunk(
  "club/deleteclub",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_club({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// club Slice
const clubSlice = createSlice({
  name: 'clubs',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:"",
      };
    },
    setClub(state, action) {
      state.clubs = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchclublist.fulfilled, (state, action) => {
        state.clublist = action.payload.data;
      })
       // Fetch club
       .addCase(fetchclub.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchclub.fulfilled, (state, action) => {
        state.loading = false;
        state.clubs = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchclub.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add club
      .addCase(createclub.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createclub.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createclub.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
        state.IsEditing = false;
      })
      // Update club
      .addCase(updateclub.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateclub.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateclub.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete club
      .addCase(deleteclub.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteclub.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteclub.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setClub,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = clubSlice.actions;
export default clubSlice.reducer;
